import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

import { htmlToReact } from 'utils/functions';
import LoadingPage from 'components/common/Loader/Spinner/Spinner';
import ThreeppModal from 'components/common/Modal/Modal';
import { MobileComment } from './MobileComment';
import { CommentInput } from './CommentInput';

const useStyles = makeStyles(theme => ({
  commentsModal: {
    '& .modal-content': {
      minHeight: '100vh',
      height: '100vh',
      overflow: 'auto',
      top: '0px'
    },
    '& .modal-header': {
      alignItems: 'center',
      textTransform: 'uppercase',
      borderBottom: 'none'
    },
    '& .modal-body': {
      overflow: 'auto'
    }
  },
  label: {
    fontWeight: 'bold',
    fonSize: theme.whitespace.base,
    color: '#212121',
    paddingTop: theme.whitespace.base,
    '& .required': {
      fontSize: 'small',
      color: 'red',
      marginRight: theme.whitespace.least
    }
  },
  answerText: {
    marginTop: theme.whitespace.less,
    paddingRight: theme.whitespace.less,
    fontWeight: 500,
    fontSize: theme.whitespace.base
  },
  comment: {
    borderTop: '1px solid lightgrey',
    padding: '1rem 0 0',
    '&:last-of-type': {
      marginBottom: '2.5rem'
    }
  }
}));

export const CommentsModal = props => {
  const {
    isLoading,
    comments,
    fieldAclAction,
    isOpen,
    question,
    toggle,
    commentMetadata,
    updateCommentsState,
    removeCommentMethod,
    currentUser,
    isAssessmentReadOnly
  } = props;
  const classes = useStyles();

  const { t } = useTranslation();

  const loader = isLoading && <LoadingPage size="md" expanded />;

  return (
    <ThreeppModal isOpen={isOpen} toggle={toggle} classes={classes.commentsModal} header={t('comments.title')} size="lg">
      {loader}
      {!isLoading && (
        <React.Fragment>
          <div className={classes.label}>
            {(question?.required === true || fieldAclAction === 'Required') && <span className="required">* </span>}
            {question?.label}
          </div>
          <div className={classes.answerText} align="left">
            {htmlToReact(question?.displayText)}
          </div>
          <CommentInput
            commentMetadata={commentMetadata}
            sourceFieldId={question.id}
            updateCommentsState={updateCommentsState}
            isAssessmentReadOnly={isAssessmentReadOnly}
          />
          {comments?.map(comment => (
            <div key={comment.id} className={classes.comment}>
              <MobileComment
                key={comment.id}
                comment={comment}
                commentMetadata={commentMetadata}
                sourceFieldId={question.id}
                updateCommentsState={updateCommentsState}
                removeCommentMethod={removeCommentMethod}
                currentUser={currentUser}
                isAssessmentReadOnly={isAssessmentReadOnly}
              />
            </div>
          ))}
        </React.Fragment>
      )}
    </ThreeppModal>
  );
};

export default CommentsModal;
